module.exports = __webpack_public_path__ + "img/Opplysningstid_Andre_kunstformer4.9d3d88c6.jpg";